import React from 'react';
import PropTypes from 'prop-types';
import AuthorizedPersonnelModal from '../AuthorizedPersonnelModal';
import ChangeCustomerState from '../ChangeCustomerState';
import CustomerAddressModal from '../CustomerAddressModal';
import CustomerCardModal from '../CustomerCardModal';
import EditCustomerModal from '../EditCustomerModal';

/**
 * The page's dialogs; `modal` names the open one. All but the "add" form act
 * on the selected customer.
 */
const CustomerModals = ({ modal, formMode, customer, onClose, onOpen, onEdit, onSaved, onStatusChanged }) => {
  if (modal === 'form') {
    return (
      <EditCustomerModal
        customer={formMode === 'edit' ? customer : null}
        onClose={onClose}
        onSaved={onSaved}
      />
    );
  }
  if (!customer) return null;

  switch (modal) {
    case 'card':
      return (
        <CustomerCardModal
          customer={customer}
          onClose={onClose}
          onEdit={onEdit}
          onOpenAddresses={() => onOpen('addresses')}
          onOpenPersonnel={() => onOpen('personnel')}
        />
      );
    case 'status':
      return <ChangeCustomerState customer={customer} onClose={onClose} onChanged={onStatusChanged} />;
    case 'addresses':
      return <CustomerAddressModal customer={customer} onClose={onClose} />;
    case 'personnel':
      return <AuthorizedPersonnelModal customer={customer} onClose={onClose} />;
    default:
      return null;
  }
};

CustomerModals.propTypes = {
  modal: PropTypes.oneOf(['card', 'form', 'status', 'addresses', 'personnel']),
  formMode: PropTypes.oneOf(['add', 'edit']).isRequired,
  customer: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  onStatusChanged: PropTypes.func.isRequired,
};

export default CustomerModals;
